"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../icons/FontAwesome");
var DropDownButtonCreate = /** @class */ (function (_super) {
    __extends(DropDownButtonCreate, _super);
    function DropDownButtonCreate(props) {
        return _super.call(this, props) || this;
    }
    DropDownButtonCreate.prototype.handleMenuClick = function (key) {
        if (this.props.onItemClick) {
            this.props.onItemClick(key);
        }
    };
    DropDownButtonCreate.prototype.getMenuItemIcon = function (iconText) {
        if (iconText) {
            return React.createElement(FontAwesome_1.FA, { left: true, icon: iconText });
        }
        else {
            return null;
        }
    };
    DropDownButtonCreate.prototype.getMenuItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.items.length; i++) {
            if (this.props.items[i].separatorBefore) {
                _ret.push(React.createElement(antd_1.Menu.Divider, { key: "before-" + this.props.items[i].key }));
            }
            _ret.push(React.createElement(antd_1.Menu.Item, { key: this.props.items[i].key },
                this.getMenuItemIcon(this.props.items[i].icon),
                this.props.items[i].value));
            if (this.props.items[i].separatorAfter) {
                _ret.push(React.createElement(antd_1.Menu.Divider, { key: "after-" + this.props.items[i].key }));
            }
        }
        return _ret;
    };
    DropDownButtonCreate.prototype.getMenu = function () {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.handleMenuClick(parseInt(e.key, 10)); } }, this.getMenuItems()));
    };
    DropDownButtonCreate.prototype.render = function () {
        return (React.createElement(antd_1.Dropdown, { overlay: this.getMenu(), trigger: ['click'] },
            React.createElement(antd_1.Tooltip, { placement: "top", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
                React.createElement(antd_1.Button, { icon: "file", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" } },
                    this.props.title,
                    " ",
                    React.createElement(antd_1.Icon, { type: "down" })))));
    };
    return DropDownButtonCreate;
}(React.Component));
exports.default = DropDownButtonCreate;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/dropdown_buttons/DropDownButtonCreate.tsx
// module id = 792
// module chunks = 0